<template>
  <article class="page page-orders page-payment">
    <section class="container-padding">
      <section>
        Content
      </section>
    </section>

    <AppCopyRightInfo />
  </article>
</template>

<script setup>
import { useRoute } from 'vue-router';

import { ref } from 'vue';
import { useHttp } from '@/composables';
import { HttpStatusCode } from 'axios';
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons';

const route = useRoute();

</script>
